import React, { useState, useEffect, useContext, useRef } from "react";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import { getApiService } from "../services/ApiService";
import { GetPayLoad } from "../services/PayLoadStorage";
import '../assets/css/Modal.css';
import { LanguageContext } from "../contexts/LanguageContext";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const ActivateAccountModal = ({ accountNumber, accountName, vaultId, accountType, setActivateModal, sendDataToParent }) => {
    
    const handleCancel = () => setActivateModal(false);
    let currentDate = moment(). format('MM/DD/YYYY');
	const Payload = GetPayLoad('PayLoad');
	const inputRef = useRef(null);

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
		"X-Hps-Region"   : Payload?.region
    };    
    const [billingInfo, setBillingInfo] = useState([]);
	const [isChecked, setIsChecked] = useState(false);
	const [isDisabled, setDisabled] = useState(false);
	const [isLoading, setLoading] = useState(false);

	const { pageContent } = useContext(LanguageContext);
    const [billingContent, setBillingContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);
	const [totalPremium, setTotalPremium] = useState(0);
	const [errorFlag, setErrorFlag] = useState(false);

	useEffect(() => {
		if (pageContent?.billing) {
            setBillingContent(pageContent.billing);
        }
        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }
		
        const targetBillingDetailsUrl = process.env.REACT_APP_API_CASE_BILL_DETAILS_ENDPOINT;
        getApiService(baseUrl, targetBillingDetailsUrl, { cim: Payload?.cim, apiSource: 'recentBilling' }, headers)
            .then((response) => {
                if (response?.data && response?.data?.status == 'SUCCESS') {
                    const result = response.data.data;
                    setBillingInfo(result);
                }
            })
            .catch(error => {
                console.error('Error fetching billing data:', error);
            });
		
		// Fetching coverage data to check to calculate the total premium only not termed cases - st48236
		const targetCoverageUrl = process.env.REACT_APP_API_COVERAGE_INFO_ENDPOINT;
		getApiService(baseUrl, targetCoverageUrl, { cim: Payload?.cim }, headers)
			.then((response) => {
				if (response?.data?.statusCode !== 200) {
					setErrorFlag(true);
				} else {
					const arrCoveragesPrd = response.data.data.coverages;
					// Calculate total premium for non-termed cases
					let calculatedPremium = 0;
					arrCoveragesPrd.forEach((coverage) => {
						if (coverage?.dtlCaseStatus?.toLowerCase() !== 'termed') {
							// Parse premium amount, removing currency symbols and commas
							const premiumValue = parseFloat(coverage?.premiumAmt?.replace(/[^0-9.-]+/g, '') || 0);
							calculatedPremium += premiumValue;
						}
					});
					setTotalPremium(calculatedPremium);
				}
			})
			.catch(error => {
				console.error('Error fetching coverage data:', error);
			});
    }, [pageContent]);

    const handleActivate = (e) => {
        e.preventDefault();
        if(isChecked){
			setDisabled(true);
			setLoading(true);
			const targetActivateAccountUrl = process.env.REACT_APP_API_ACTIVATE_ACCOUNT_ENDPOINT;
			getApiService(baseUrl, targetActivateAccountUrl, { cim: Payload?.cim, vault_id: vaultId, account_type: accountType }, headers)
				.then((response) => {
					setLoading(false);
					if (response?.data?.statusCode !== 200) {
						setDisabled(false);
						sendDataToParent(genericContent?.service_post_error, 'tab1', 'error');
                	}else{
						const result = response.data.data;
						if(result){
							setActivateModal(false);
							sendDataToParent(billingContent?.billing_activate_account_success_msg+accountName+'.', 'tab1', 'success');
						}
					}
				})
				.catch(error => {
					setLoading(false);
					setDisabled(false);
					sendDataToParent(genericContent?.service_post_error, 'tab1', 'error');
				});
		}else{
			if (inputRef.current) {
				inputRef.current.focus();
			}
		}
    }
	//sakthi - to calculate the total premium - for activate account
	const currentDue = parseFloat(billingInfo?.CurrentDueAmount?.replace('$', '')) || 0;
	const lastPayment = parseFloat(billingInfo?.LastPaymentRecvd?.replace('$', '')) || 0;
	const totalDueAmount = "$"+(totalPremium!==0?totalPremium:(currentDue + lastPayment).toFixed(2));
	const nachaAuthContent = DOMPurify.sanitize(accountType === 'EFT' ? billingContent?.billing_eft_recurring_nacha_content : billingContent?.billing_cc_recurring_nacha_content);
	let modifiedNachaAuthContent = nachaAuthContent;
	modifiedNachaAuthContent = nachaAuthContent ? modifiedNachaAuthContent.replace(/{{currentDate}}/g, currentDate) : '';
	modifiedNachaAuthContent = nachaAuthContent ? modifiedNachaAuthContent.replace(/{{CurrentDueAmount}}/g, totalDueAmount) : ''; //sakthi - to calculate the total premium - for activate account
	modifiedNachaAuthContent = nachaAuthContent ? modifiedNachaAuthContent.replace(/{{accountNumber}}/g, accountNumber) : '';

	const nachaNoticeCancelContent = DOMPurify.sanitize(billingContent?.billing_recurring_nacha_content_notice_change_cancel);
	const nachaContentHolderContent = DOMPurify.sanitize(accountType === 'EFT' ? billingContent?.billing_eft_recurring_nacha_content_holder_agreement : billingContent?.billing_cc_recurring_nacha_content_holder_agreement);

    return (
        
        <div>
			<div className="modal-header pb-4">
				<button type="button" className="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close" onClick={handleCancel}></button>
			</div>

			<div className="modal-body activate-account-modal" tabIndex={0}>
				
				{parse(modifiedNachaAuthContent)}
				
				{parse(nachaNoticeCancelContent)}

				{parse(nachaContentHolderContent)}

				<div>
					<p className="fw-medium fs-6">
						<strong>
							<label for="nacha-auth-e-signature-checkbox">
							<input type="checkbox" 
							id="nacha-auth-e-signature-checkbox" 
							name="nacha-auth-e-signature-checkbox" 
							value="true" style={{cursor: 'pointer'}}
							ref={inputRef}
							onChange={(e) => setIsChecked(e.target.checked)}/> {billingContent?.billing_recurring_nacha_content_e_signature}
							<p className={isChecked ? '' : "text-danger"}><span>* </span>{billingContent?.billing_recurring_nacha_content_e_signature_instruction}</p>
							</label>
						</strong>
					</p>
					{isLoading && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                        <Spinner animation="border" role="status" ></Spinner>
                        <div style={{fontSize: "12px"}}>{genericContent?.loading_message}</div>
                        </div>
                    )}
				</div>

				<div className="col-12">
					
					{/* Responsive button order for Q5 carrier */}
					{Payload?.owning_carrier === 'Q5' ? (
						<>
							{/* Mobile/Tablet: Activate top, Cancel bottom */}
							<div className="d-block d-lg-none">
								<input
									type="submit"
									aria-label="submit"
									className="btn btn-secondary btn-lg mt-4 col-5"
									onClick={handleActivate}
									value={billingContent?.billing_activate_account_text}
									required=""
									disabled={isDisabled}
								/>
								
								<input
									type="button"
									aria-label="Cancel"
									className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5"
									value={billingContent?.billing_cancel_request_text}
									data-bs-toggle="modal"
									href="#exampleModalFullscreen"
									onClick={handleCancel}
								/>
							</div>
							{/* Large screens: Cancel first, Activate second */}
							<div className="d-none d-lg-flex">
								<input
									type="button"
									aria-label="Cancel"
									className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5"
									value={billingContent?.billing_cancel_request_text}
									data-bs-toggle="modal"
									href="#exampleModalFullscreen"
									onClick={handleCancel}
								/>
								<input
									type="submit"
									aria-label="submit"
									className="btn btn-secondary btn-lg mt-4 col-5"
									onClick={handleActivate}
									value={billingContent?.billing_activate_account_text}
									required=""
									disabled={isDisabled}
								/>
							</div>
						</>
					) : (
						<>
							<input type="button" aria-label="Canel"
								className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5" value={billingContent?.billing_cancel_request_text}
								data-bs-toggle="modal" href="#exampleModalFullscreen" onClick={handleCancel} />
							<input type="submit" aria-label="submit" className="btn btn-secondary btn-lg mt-4 col-5"
								onClick={handleActivate} value={billingContent?.billing_activate_account_text} required="" disabled={isDisabled} />
						</>
					)}
				</div>
			</div>
        </div>
    )
}

export default ActivateAccountModal;